import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_tfwwrn4db2: FaireBrandEntity = {
  token: "b_tfwwrn4db2",
  type: "brand",
  name: "The Lounge Edit",
  avatarUrl:
    "https://cdn.faire.com/fastly/30ae7571a2aaef0dc9e1cc9032a631678562d6aea5bc22d55ec523c8b260df4b.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/aea87fa2a1a3b42faaa6e885120379105ed491feb259180c4a0400650752be8e.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/30ae7571a2aaef0dc9e1cc9032a631678562d6aea5bc22d55ec523c8b260df4b.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/aea87fa2a1a3b42faaa6e885120379105ed491feb259180c4a0400650752be8e.jpeg",
  location: "Mississauga, ON, CAN",
  minimumOrderDollars: 69,
  rating: 4.5,
  reviewCount: 2,
  isInsider: false,
  description:
    "At The Lounge Edit, we believe that comfort and style should never be mutually exclusive. Our curated collection of luxurious loungewear is designed for the modern individual who values both relaxation and elegance. From cozy pajamas to effortless jumpsuits and chic dresses, our pieces are crafted to make you feel at ease without compromising your sense of fashion.\n\nBorn out of a desire to bring style into every aspect of life, The Lounge Edit embraces the art of laid-back sophistication. Whether you’re unwinding at home, enjoying a weekend brunch, or traveling, our loungewear effortlessly adapts to every moment of your day. Our pieces are thoughtfully designed with soft fabrics, flattering cuts, and timeless silhouettes, ensuring you always look and feel your best.\n\nAt The Lounge Edit, we’re not just creating clothing; we’re curating an experience of everyday luxury. Our collection reflects the belief that comfort is a lifestyle, and style is a state of mind. Welcome to a new era of loungewear—where relaxation meets refinement.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:50.864Z",
    importedBy: "entity-db-cli",
  },
};
